export type CongestionLevel = '여유' | '보통' | '혼잡' | '만차';

export interface ParkingPlace {
  id: number;
  name: string;
  area: string;
  congestionLevel: CongestionLevel;
  parkingPlaceEnabled: boolean;
}
export interface ParkingData {
  parkingId: number;
  announcement: string;
  parkingPlaces: ParkingPlace[];
  congestionEnabled: boolean;
  announcementEnabled: boolean;
}

// utils/congestionLevelMapper.ts
export const congestionMapper = {
  LOW: '여유',
  MEDIUM: '보통',
  HIGH: '혼잡',
  FULL: '만차',
};

export const reverseCongestionMapper = {
  여유: 'LOW',
  보통: 'MEDIUM',
  혼잡: 'HIGH',
  만차: 'FULL',
};

export const congestionColors = {
  여유: {
    textColor: '#2BB704',
    bgColor: '#31D205',
  },
  보통: {
    textColor: '#E9AB00',
    bgColor: '#FB0',
  },
  혼잡: {
    textColor: '#DF0000',
    bgColor: '#EF0101',
  },
  만차: {
    textColor: '#505050',
    bgColor: '#505050',
  },
  운영마감: {
    textColor: '#CCC',
    bgColor: '#CCC',
  },
};
